<div class="flex flex-col justify-center items-center" [class]="getContainerMarginClasses()">
  <!-- Main Box with Logo & BotMaa Text -->
  @if (showBox) {
    <div
      class="border-2 border-gray-300 rounded-lg inline-block text-center"
      [class]="getBoxPaddingClasses()"
    >
      <div class="flex items-center justify-center">
        <img
          [src]="logoSrc"
          [alt]="logoAlt"
          [class]="
            getLogoWidthClasses() + ' ' + getLogoHeightClasses() + ' ' + getLogoMarginClasses()
          "
        />
        <h1 class="font-bold" [class]="getTitleSizeClasses()">
          {{ getTitleParts().first }}<span [class]="titleColor">{{ getTitleParts().second }}</span>
        </h1>
      </div>
    </div>
  } @else {
    <!-- Without box border -->
    <div class="flex items-center justify-center">
      <img
        [src]="logoSrc"
        [alt]="logoAlt"
        [class]="
          getLogoWidthClasses() + ' ' + getLogoHeightClasses() + ' ' + getLogoMarginClasses()
        "
      />
      <h1 class="font-bold" [class]="getTitleSizeClasses()">
        {{ getTitleParts().first }}<span [class]="titleColor">{{ getTitleParts().second }}</span>
      </h1>
    </div>
  }

  <!-- Footer Text -->
  @if (showFooterText) {
    <p
      [class]="
        getFooterSizeClasses() + ' ' + footerTextColor + ' text-center ' + getFooterMarginClasses()
      "
    >
      {{ footerText }}
    </p>
  }
</div>
